module.exports = __webpack_public_path__ + "img/number-1.3a89d3fa.svg";